import { getMarketByLocale } from "../utils/locales";

export const SLUG_DEFAULT = "default";
export const SLUG_CLINICAL = "clinical";
export const SLUG_CLINICAL2 = "clinical-v2";
export const SLUG_UNI1 = "var1-vs";
export const SLUG_UNI2 = "var2-vs";
export const SLUG_UNI3 = "var3-vs";
export const SLUG_UNI4 = "var4-vs";
export const SLUG_UNI5 = "var5-vs";
export const SLUG_ELI = "clinical-vip";
export const SLUG_FOOD_NOISE = "food-noise";
export const ALL_SLUGS = [
  SLUG_DEFAULT,
  SLUG_CLINICAL,
  SLUG_CLINICAL2,
  SLUG_UNI1,
  SLUG_UNI2,
  SLUG_UNI3,
  SLUG_UNI4,
  SLUG_UNI5,
  SLUG_ELI,
  SLUG_FOOD_NOISE
];

const config = {
  AU: {
    default: {
      dbSlugs: ["gtky9", "guided-selling9"],
      urlSlug: SLUG_DEFAULT
    },
    doShowCoachQuestionFuncName: "isPremiumOrCoaching",
    guidedSellingResultsFunction: "guidedSellingAU",
    legalUnderCta: false
  },
  FB: {
    default: {
      dbSlugs: ["gtky9", "guided-selling9"],
      urlSlug: SLUG_DEFAULT
    },
    doShowCoachQuestionFuncName: "checkIsPremium",
    guidedSellingResultsFunction: "guidedSelling",
    legalUnderCta: false
  },
  NB: {
    default: {
      dbSlugs: ["gtky9", "guided-selling9"],
      urlSlug: SLUG_DEFAULT
    },
    doShowCoachQuestionFuncName: "checkIsPremium",
    guidedSellingResultsFunction: "guidedSelling",
    legalUnderCta: false
  },
  CA: {
    default: {
      dbSlugs: ["gtky9", "guided-selling9"],
      urlSlug: SLUG_DEFAULT
    },
    doShowCoachQuestionFuncName: "checkIsPremium",
    guidedSellingResultsFunction: "guidedSelling",
    legalUnderCta: false
  },
  FC: {
    default: {
      dbSlugs: ["gtky9", "guided-selling9"],
      urlSlug: SLUG_DEFAULT
    },
    doShowCoachQuestionFuncName: "checkIsPremium",
    guidedSellingResultsFunction: "guidedSelling",
    legalUnderCta: false
  },
  DE: {
    default: {
      dbSlugs: ["gtky9", "guided-selling9"],
      urlSlug: SLUG_DEFAULT
    },
    doShowCoachQuestionFuncName: "checkIsPremium",
    guidedSellingResultsFunction: "guidedSelling",
    legalUnderCta: false
  },
  FR: {
    default: {
      dbSlugs: ["gtky9", "guided-selling9"],
      urlSlug: SLUG_DEFAULT
    },
    doShowCoachQuestionFuncName: "checkIsPremium",
    guidedSellingResultsFunction: "guidedSelling",
    legalUnderCta: false
  },
  NZ: {
    default: {
      dbSlugs: ["gtky9", "guided-selling9"],
      urlSlug: SLUG_DEFAULT
    },
    doShowCoachQuestionFuncName: "isPremiumOrCoaching",
    guidedSellingResultsFunction: "guidedSellingAU",
    legalUnderCta: false
  },
  SE: {
    default: {
      dbSlugs: ["gtky9", "guided-selling9"],
      urlSlug: SLUG_DEFAULT
    },
    doShowCoachQuestionFuncName: "checkIsPremium",
    guidedSellingResultsFunction: "guidedSelling",
    legalUnderCta: false
  },
  UK: {
    default: {
      dbSlugs: ["gtky9", "guided-selling9"],
      urlSlug: SLUG_DEFAULT
    },
    doShowCoachQuestionFuncName: "checkIsPremium",
    guidedSellingResultsFunction: "guidedSelling",
    legalUnderCta: false
  },
  US: {
    default: {
      dbSlugs: ["gtky9", "guided-selling9"],
      urlSlug: SLUG_DEFAULT
    },
    eli: {
      dbSlugs: ["gtky10", "guided-selling10"],
      urlSlug: SLUG_ELI
    },
    isSequence: {
      dbSlugs: ["gtky11", "guided-selling11"],
      urlSlug: SLUG_CLINICAL
    },
    clinical: {
      dbSlugs: ["clinical"],
      urlSlug: SLUG_CLINICAL2
    },
    uni1: {
      dbSlugs: ["unified-assessment-v1"],
      urlSlug: SLUG_UNI1
    },
    uni2: {
      dbSlugs: ["unified-assessment-v2"],
      urlSlug: SLUG_UNI2
    },
    uni3: {
      dbSlugs: ["unified-assessment-v3"],
      urlSlug: SLUG_UNI3
    },
    uni4: {
      dbSlugs: ["unified-assessment-v4"],
      urlSlug: SLUG_UNI4
    },
    uni5: {
      dbSlugs: ["unified-assessment-v5"],
      urlSlug: SLUG_UNI5
    },
    foodNoise: {
      dbSlugs: ["food-noise"],
      urlSlug: SLUG_FOOD_NOISE
    },
    doShowCoachQuestionFuncName: "checkIsPremium",
    guidedSellingResultsFunction: "guidedSelling",
    legalUnderCta: true
  }
};

export function getConfigByLocale(locale) {
  const market = getMarketByLocale(locale);
  return config[market];
}
